import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { masterActions } from "stores/master/masterActions";
import { commonActions } from "stores/common/commonActions";
import { dashboardActions } from "stores/dashboard/dashboardActions";
import { jarvsiOnestockOnboardingActions } from "stores/jarvisOnestock/jarvisOnestockOnboarding/jarvisOnestockOnboardingAction";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";

const mapStateToProps = (state) => ({
  blogs: state.common.blogs || [],
  investingEssentials: state.dashboard.investingEssentials || [],
  privateWealth: state.dashboard.privateWealth || [],
  disabledProductCodes: state.dashboard.disabledProductCodes || [],
  productsLoading: state.dashboard.loading.productDetails === 1,
  pendingCallData: state.master.pendingCall,
  isProfileNavEnabled: !!(
    state.onboarding.isOnboardingCompleted ||
    state.jarvisRMS.rmsOnboarding.isOnboardingCompleted ||
    state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted ||
    state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted ||
    state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted ||
    state.PHC.PHCOnboarding.isOnboardingCompleted
  ),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPortfolioOnboardingDataAction: onboardingActions.getOnboardingData,
      updatePortfolioOnboardingDataAction: onboardingActions.updateOnboardingData,
      updateOnestockOnboardingDataAction:
        jarvsiOnestockOnboardingActions.updateOnestockOnboardingData,
      updateRMSOnboardingDataAction:
        jarvsiRMSOnboardingActions.updateRMSOnboardingData,
      getRiskDetails: masterActions.getRiskDetails,
      getFirstRender: masterActions.getFirstRender,
      getBlogsAction: commonActions.getBlogs,
      getProductDetailsAction: dashboardActions.getProductDetails,
      getPendingCallAction: masterActions.getPendingCall,
    },
    dispatch,
  );

const UnifiedDashboardStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default UnifiedDashboardStore;
